import React, { useEffect, } from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger, UseFormWatch } from 'react-hook-form';
import { direccionGarantia } from '../../models/garantias';
import { selectorTransversal } from '../../../../dtos/selector';
import PropiedadNueva from './propiedadNueva';
import PropiedadUsada from './propiedadUsada';
import { Dominios, TipoPropiedad } from '../../../../utils/enums';
import { Grid2, Typography } from '@mui/material';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';



interface FormProps<T> {
    control: Control<direccionGarantia, undefined>;
    listaTipoPropiedad: selectorTransversal[];
    listarTipoPropiedad: (dominio: Dominios) => Promise<void>;
    errors: FieldErrors<direccionGarantia>;
    setValue: UseFormSetValue<direccionGarantia>;
    isEditing: boolean;
    trigger: UseFormTrigger<direccionGarantia>;
    tipoPropiedad: string;
    esVigente?: boolean;
    permisoCarteraMutuoEditarInfo?: boolean;
    isReadonlyWithPermission?: boolean;
}

const TipoPropiedadForm: React.FC<FormProps<any>> = ({
    control,
    listaTipoPropiedad,
    listarTipoPropiedad,
    errors,
    setValue,
    tipoPropiedad,
    isEditing,
    trigger,
    esVigente,
    permisoCarteraMutuoEditarInfo,
    isReadonlyWithPermission
}) => {
   
    useEffect(() => {
        listarTipoPropiedad(Dominios.TIPO_PROPIEDAD);
    }, []);

    const handleTipoPropiedad = () => {
        //Se limpia inmobiliaria
        setValue('rutInmobiliaria', '');
        setValue('nombreInmobiliaria', '');

        // Se limpia datos
        setValue('rutVendedor', '');
        setValue('nombreVendedor', '');
        setValue('emailVendedor', '');
        setValue('otrosVendedores', '');
    }

    return (
        <>
            <Typography className='card-title' variant="h6">Datos vendedor</Typography>
            <Grid2 container spacing={2} mt={2}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputSelect
                        readonly={isReadonlyWithPermission}
                        label="Tipo propiedad"
                        name="tipoPropiedad"
                        control={control}
                        options={listaTipoPropiedad}
                        onChange={() => handleTipoPropiedad()}
                        error={errors.tipoPropiedad}
                    />
                </Grid2>

            </Grid2>
            {
                tipoPropiedad &&
                <Grid2 container sx={{ mb: 3 }}>
                    {
                        tipoPropiedad === TipoPropiedad.Nueva ?
                            <PropiedadNueva
                                control={control}
                                setValue={setValue}
                                isEditing={isEditing}
                                errors={errors}
                                trigger={trigger}
                                esVigente={esVigente}
                                isReadonlyWithPermission = {isReadonlyWithPermission}
                            />
                            :
                            <PropiedadUsada
                                control={control}
                                errors={errors}
                                isEditing={isEditing}
                                esVigente={esVigente}
                                isReadonlyWithPermission = {isReadonlyWithPermission}
                            />
                    }
                </Grid2>
            }
        </>
    );
};

export default TipoPropiedadForm;